module.exports = __webpack_public_path__ + "images/CEBSB_goodnews_bg_up.1789545008192.png";